(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  // Collection intro: two lines with a "Read more" toggle, shown only when the text runs longer.
  if (!window.collectionEditorialDescriptionBound) {
    window.collectionEditorialDescriptionBound = true;

    const fitDescription = (root = document) => {
      root.querySelectorAll('[data-collection-description]').forEach((wrapper) => {
        const text = wrapper.querySelector('.collection-editorial-hero__description-text');
        const toggle = wrapper.querySelector('[data-collection-description-toggle]');
        if (!text || !toggle || wrapper.classList.contains('is-expanded')) return;
        toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target instanceof Element ? event.target.closest('[data-collection-description-toggle]') : null;
      if (!toggle) return;
      const wrapper = toggle.closest('[data-collection-description]');
      if (!wrapper) return;
      const expanded = wrapper.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
    });

    let fitFrame = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(fitFrame);
      fitFrame = requestAnimationFrame(() => fitDescription());
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) fitDescription(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => fitDescription(), { once: true });
    } else {
      fitDescription();
    }
    // Web fonts can change the line count after first paint.
    document.fonts?.ready.then(() => fitDescription());
  }

  if (!window.collectionEditorialHandlersBound) {
    window.collectionEditorialHandlersBound = true;

    const closeCollectionEditorialDrawer = (drawer) => {
      if (!drawer) return;

      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('collection-editorial-drawer-open');

      const opener = document.querySelector(`[data-collection-mobile-drawer-open="${drawer.id}"]`);
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }

      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 240);
    };

    const closeAllCollectionEditorialDrawers = () => {
      document.querySelectorAll('[data-collection-mobile-drawer].is-open').forEach((drawer) => {
        closeCollectionEditorialDrawer(drawer);
      });
    };

    const closeCollectionEditorialSortDropdown = (dropdown) => {
      if (!dropdown) return;

      dropdown.classList.remove('is-open');
      dropdown.setAttribute('aria-hidden', 'true');

      const opener = document.querySelector(`[data-collection-mobile-sort-toggle="${dropdown.id}"]`);
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }
    };

    const closeAllCollectionEditorialSortDropdowns = () => {
      document.querySelectorAll('[data-collection-mobile-sort-dropdown].is-open').forEach((dropdown) => {
        closeCollectionEditorialSortDropdown(dropdown);
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const drawerOpenButton = target.closest('[data-collection-mobile-drawer-open]');
      if (drawerOpenButton) {
        const drawerId = drawerOpenButton.getAttribute('data-collection-mobile-drawer-open');
        const drawer = drawerId ? document.getElementById(drawerId) : null;
        if (!drawer) return;

        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();
        drawer.hidden = false;
        drawerOpenButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('collection-editorial-drawer-open');
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
        });

        const panel = drawer.querySelector('.collection-editorial-mobile-drawer__panel');
        if (panel) {
          panel.focus({ preventScroll: true });
        }

        return;
      }

      const drawerCloseButton = target.closest('[data-collection-mobile-drawer-close]');
      if (drawerCloseButton) {
        closeCollectionEditorialDrawer(drawerCloseButton.closest('[data-collection-mobile-drawer]'));
        return;
      }

      const sortToggleButton = target.closest('[data-collection-mobile-sort-toggle]');
      if (sortToggleButton) {
        const dropdownId = sortToggleButton.getAttribute('data-collection-mobile-sort-toggle');
        const dropdown = dropdownId ? document.getElementById(dropdownId) : null;
        if (!dropdown) return;

        const willOpen = !dropdown.classList.contains('is-open');
        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();

        if (willOpen) {
          dropdown.classList.add('is-open');
          dropdown.setAttribute('aria-hidden', 'false');
          sortToggleButton.setAttribute('aria-expanded', 'true');
        }

        return;
      }

      if (!target.closest('.collection-editorial-toolbar')) {
        closeAllCollectionEditorialSortDropdowns();
      }

      const button = target.closest('[data-grid-view-value]');
      if (!button) return;

      const section = button.closest('[data-collection-editorial]');
      if (!section) return;

      const value = button.getAttribute('data-grid-view-value') || 'default';
      section.setAttribute('data-grid-view', value);

      section.querySelectorAll('[data-grid-view-value]').forEach((control) => {
        control.classList.toggle('is-active', control === button);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllCollectionEditorialDrawers();
        closeAllCollectionEditorialSortDropdowns();
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-collection-mobile-drawer]').forEach((drawer) => {
        closeCollectionEditorialDrawer(drawer);
      });
      event.target.querySelectorAll('[data-collection-mobile-sort-dropdown]').forEach((dropdown) => {
        closeCollectionEditorialSortDropdown(dropdown);
      });
    });
  }

  // Filters apply without a page load. Desktop checkboxes, the in-stock switch, price, sort, chips and
  // Clear all build the URL from their form or link, this section is rendered for it with the Section
  // Rendering API, and the toolbar and results are swapped in. History gets the clean URL, so Back and
  // Forward re-render. Older requests are aborted; a failed render falls back to a normal page load.
  // Without JS every form still submits as a GET request.
  // The mobile drawer stays Apply-based: its Apply button reads "See 12 items", refreshed from this
  // section re-rendered with the form's values. Labels come from Liquid (actions.see_items), so every
  // locale's plural forms stay correct.
  if (!window.collectionEditorialFiltersBound) {
    window.collectionEditorialFiltersBound = true;

    const RESULTS_DEBOUNCE_MS = 250;
    const resultsTimers = new WeakMap();
    const resultsRequests = new WeakMap();
    const renderRequests = new WeakMap();
    const HISTORY_KEY = 'collectionEditorial';

    // Form values as a URL, without empty fields (price inputs) and with the clicked submit button's value.
    const formUrl = (form, submitter) => {
      const url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (typeof value === 'string' && value.trim() !== '') params.append(key, value.trim());
      });
      if (submitter?.name) params.set(submitter.name, submitter.value);
      url.search = params.toString();
      return url;
    };

    // The collection's default sort stays out of the URL.
    const withoutDefaultSort = (section, url) => {
      const defaultSort = section.querySelector('[data-default-sort]')?.getAttribute('data-default-sort');
      if (defaultSort && url.searchParams.get('sort_by') === defaultSort) url.searchParams.delete('sort_by');
      return url;
    };

    // The desktop filter form plus the sort select, which lives in its own form.
    const desktopUrl = (section) => {
      const form = section.querySelector('[data-collection-form="desktop"]');
      const sort = section.querySelector('[data-collection-form="sort"] select[name="sort_by"]');
      if (!form && !sort) return null;
      const url = formUrl(form || sort.form);
      if (sort) url.searchParams.set('sort_by', sort.value);
      return withoutDefaultSort(section, url);
    };

    // `sections=` (JSON) first: `shopify theme dev` intermittently 404s `section_id=`; then `section_id=`.
    const fetchSection = async (url, sectionId, signal) => {
      const attempts = [
        ['sections', async (response) => (await response.json())?.[sectionId]],
        ['section_id', (response) => response.text()],
      ];
      for (const [param, read] of attempts) {
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set(param, sectionId);
        try {
          const response = await fetch(fetchUrl.toString(), { signal });
          if (!response.ok) continue;
          const html = await read(response);
          if (typeof html === 'string' && html.includes('data-collection-editorial')) return html;
        } catch (error) {
          if (error?.name === 'AbortError') throw error;
        }
      }
      return null;
    };

    // Search inside long value lists: hides values whose label doesn't contain the text (any case, any
    // accents). Checked values always stay visible. Every list renders the field `hidden`; JS shows it only
    // when the list has more values than its data-filter-search-min (the Liquid filter_search_min_values).
    const normalizeSearch = (text) =>
      text.normalize('NFKD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().trim();

    const applyFilterSearch = (field) => {
      const input = field.querySelector('[data-filter-search-input]');
      const list = field.nextElementSibling;
      if (!input || !(list instanceof HTMLUListElement)) return;
      const query = normalizeSearch(input.value);
      let matches = 0;
      list.querySelectorAll(':scope > li').forEach((item) => {
        const label = item.querySelector('label > span')?.textContent || '';
        const match = !query || normalizeSearch(label).includes(query);
        if (match) matches += 1;
        item.hidden = !match && !item.querySelector('input:checked');
      });
      const empty = field.querySelector('[data-filter-search-empty]');
      if (empty) empty.hidden = matches > 0;
    };

    const showFilterSearch = (root = document) => {
      root.querySelectorAll('[data-filter-search]').forEach((field) => {
        const list = field.nextElementSibling;
        const min = Number(field.dataset.filterSearchMin) || 10;
        field.hidden = !(list instanceof HTMLUListElement) || list.children.length <= min;
        if (!field.hidden) applyFilterSearch(field);
      });
    };

    document.addEventListener('input', (event) => {
      const field = event.target instanceof Element ? event.target.closest('[data-filter-search]') : null;
      if (field) applyFilterSearch(field);
    });

    // Enter in a search field would submit the filter form; it only searches.
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target instanceof Element && event.target.matches('[data-filter-search-input]')) {
        event.preventDefault();
      }
    });

    // Which control had focus, so the same control (by form, name and value) gets it back after the swap.
    // Active-filter chips live above the results (outside the toolbar), so they are looked up in the section.
    const chipLinks = (section) => [
      ...section.querySelectorAll('.collection-editorial-active-filters [data-collection-filter-link]'),
    ];

    const describeFocus = (section, toolbar) => {
      const active = document.activeElement;
      if (!(active instanceof HTMLElement) || !section.contains(active)) return null;
      const chips = chipLinks(section);
      if (chips.includes(active)) return { chipIndex: chips.indexOf(active) };
      if (!toolbar.contains(active)) return { fallback: true };
      if (active.matches('[data-filter-search-input]')) {
        return {
          searchKey: active.closest('[data-filter-key]')?.getAttribute('data-filter-key'),
          text: { start: active.selectionStart, end: active.selectionEnd },
        };
      }
      const formKey = active.closest('[data-collection-form]')?.getAttribute('data-collection-form');
      if (formKey && 'name' in active && active.name) {
        const isText = active instanceof HTMLInputElement && active.type === 'text';
        return {
          formKey,
          name: active.name,
          value: active instanceof HTMLInputElement && !isText ? active.value : null,
          text: isText ? { value: active.value, start: active.selectionStart, end: active.selectionEnd } : null,
        };
      }
      if (active.matches('summary')) {
        return { summaryKey: active.closest('[data-filter-key]')?.getAttribute('data-filter-key') };
      }
      return { fallback: true };
    };

    const restoreFocus = (section, toolbar, focus) => {
      if (!focus) return;
      let target = null;
      if (focus.formKey) {
        const form = toolbar.querySelector(`[data-collection-form="${focus.formKey}"]`);
        target = form
          ? [...form.elements].find(
              (element) => element.name === focus.name && (focus.value === null || element.value === focus.value)
            )
          : null;
        if (target && focus.text) {
          target.value = focus.text.value;
          target.setSelectionRange?.(focus.text.start, focus.text.end);
        }
      } else if (focus.searchKey) {
        target = toolbar.querySelector(`[data-filter-key="${CSS.escape(focus.searchKey)}"] [data-filter-search-input]`);
        target?.setSelectionRange?.(focus.text.start, focus.text.end);
      } else if (focus.summaryKey) {
        target = toolbar.querySelector(`[data-filter-key="${CSS.escape(focus.summaryKey)}"] > summary`);
      } else if (typeof focus.chipIndex === 'number') {
        const chips = chipLinks(section);
        target = chips[Math.min(focus.chipIndex, chips.length - 1)] || null;
      }
      if (!target || !target.getClientRects().length) {
        target = [
          toolbar.querySelector('[data-collection-count]'),
          toolbar.querySelector('[data-collection-mobile-drawer-open]'),
        ].find((element) => element && element.getClientRects().length);
      }
      target?.focus({ preventScroll: true });
    };

    // Swaps the toolbar and the results for the rendered ones, keeping open groups, scroll and focus.
    const swapSection = (section, next, options) => {
      const toolbar = section.querySelector('.collection-editorial-toolbar');
      const results = section.querySelector('[data-collection-results]');
      const nextToolbar = next.querySelector('.collection-editorial-toolbar');
      const nextResults = next.querySelector('[data-collection-results]');

      const openGroups = new Map();
      toolbar.querySelectorAll('details[data-filter-key]').forEach((details) => {
        openGroups.set(details.getAttribute('data-filter-key'), {
          open: details.open,
          scroll: details.querySelector('.collection-editorial-filter__panel')?.scrollTop || 0,
          search: details.querySelector('[data-filter-search-input]')?.value || '',
        });
      });
      const focus = options.focusOpener ? null : describeFocus(section, toolbar);

      nextToolbar.querySelectorAll('details[data-filter-key]').forEach((details) => {
        const state = openGroups.get(details.getAttribute('data-filter-key'));
        if (!state) return;
        details.open = state.open;
        // A group that stays open keeps its search text.
        const search = details.querySelector('[data-filter-search-input]');
        if (search && state.open) search.value = state.search;
      });
      const view = section.getAttribute('data-grid-view') || 'default';
      nextToolbar.querySelectorAll('[data-grid-view-value]').forEach((control) => {
        control.classList.toggle('is-active', control.getAttribute('data-grid-view-value') === view);
      });

      toolbar.replaceWith(nextToolbar);
      results.replaceWith(nextResults);
      showFilterSearch(nextToolbar);

      // The header count beside the title follows the filtered list.
      const titleCount = section.querySelector('[data-collection-title-count]');
      const nextTitleCount = next.querySelector('[data-collection-title-count]');
      if (titleCount && nextTitleCount) titleCount.textContent = nextTitleCount.textContent;

      nextToolbar.querySelectorAll('details[open][data-filter-key]').forEach((details) => {
        const panel = details.querySelector('.collection-editorial-filter__panel');
        const state = openGroups.get(details.getAttribute('data-filter-key'));
        if (panel && state) panel.scrollTop = state.scroll;
      });
      showResultsLabels(nextToolbar);

      if (options.focusOpener) {
        nextToolbar.querySelector('[data-collection-mobile-drawer-open]')?.focus({ preventScroll: true });
      } else {
        restoreFocus(section, nextToolbar, focus);
      }

      // When the list was scrolled past, bring its top back under the sticky toolbar.
      const toolbarBottom = nextToolbar.getBoundingClientRect().bottom;
      const resultsTop = nextResults.getBoundingClientRect().top;
      if (resultsTop < toolbarBottom) window.scrollBy(0, resultsTop - toolbarBottom - 16);

      const status = section.querySelector('[data-collection-status]');
      const count = nextToolbar.querySelector('[data-collection-count]');
      if (status && count) status.textContent = count.textContent.trim();

      document.dispatchEvent(new CustomEvent('collection-editorial:render', { detail: { section } }));
    };

    // history: 'push' (a change), 'none' (Back/Forward).
    const renderSection = async (section, url, options = {}) => {
      const sectionId = section.getAttribute('data-section-id');
      if (!sectionId || !url) return;
      const href = url.toString();
      const pending = renderRequests.get(section);
      if (pending?.href === href) return;
      if (!pending && options.history === 'push' && href === window.location.href) return;

      pending?.controller.abort();
      const controller = new AbortController();
      renderRequests.set(section, { controller, href });
      section.querySelector('[data-collection-results]')?.setAttribute('aria-busy', 'true');
      section.classList.add('is-filtering');

      try {
        const html = await fetchSection(url, sectionId, controller.signal);
        if (renderRequests.get(section)?.controller !== controller) return;
        const next = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-collection-editorial]') : null;
        if (
          !next?.querySelector('.collection-editorial-toolbar') ||
          !next.querySelector('[data-collection-results]') ||
          !section.querySelector('.collection-editorial-toolbar') ||
          !section.querySelector('[data-collection-results]')
        ) {
          throw new Error('Section unavailable');
        }
        if (options.history === 'push') {
          history.pushState({ ...(history.state || {}), [HISTORY_KEY]: true }, '', href);
        }
        swapSection(section, next, options);
      } catch (error) {
        if (error?.name === 'AbortError' || renderRequests.get(section)?.controller !== controller) return;
        window.location.assign(href);
      } finally {
        if (renderRequests.get(section)?.controller === controller) {
          renderRequests.delete(section);
          // The new results come in dimmed and ease back up.
          window.requestAnimationFrame(() => {
            if (renderRequests.has(section)) return;
            section.classList.remove('is-filtering');
            section.querySelector('[data-collection-results]')?.removeAttribute('aria-busy');
          });
        }
      }
    };

    const sectionOf = (element) => element.closest('[data-collection-editorial]');

    const closeDrawerOf = (element) => {
      element.closest('[data-collection-mobile-drawer]')?.querySelector('[data-collection-mobile-drawer-close]')?.click();
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (target.matches('[data-filter-search-input]')) return;
      const form = target.closest('[data-collection-form]');
      const section = form ? sectionOf(form) : null;
      if (!section) return;
      const formKey = form.getAttribute('data-collection-form');
      if (formKey === 'desktop' || (formKey === 'sort' && target.name === 'sort_by')) {
        renderSection(section, desktopUrl(section), { history: 'push' });
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const formKey = form.getAttribute('data-collection-form');
      const section = formKey ? sectionOf(form) : null;
      if (!section) return;
      event.preventDefault();

      if (formKey === 'desktop' || formKey === 'sort') {
        renderSection(section, desktopUrl(section), { history: 'push' });
      } else if (formKey === 'mobile') {
        closeDrawerOf(form);
        renderSection(section, withoutDefaultSort(section, formUrl(form)), { history: 'push', focusOpener: true });
      } else if (formKey === 'mobile-sort') {
        const opener = section.querySelector('[data-collection-mobile-sort-toggle][aria-expanded="true"]');
        opener?.click();
        renderSection(section, withoutDefaultSort(section, formUrl(form, event.submitter)), { history: 'push' });
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const link = target.closest('[data-collection-filter-link], .collection-editorial-empty__link');
      if (link instanceof HTMLAnchorElement) {
        const section = sectionOf(link);
        if (!section || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const inDrawer = Boolean(link.closest('[data-collection-mobile-drawer]'));
        closeDrawerOf(link);
        renderSection(section, new URL(link.href), { history: 'push', focusOpener: inDrawer });
        return;
      }

      // Desktop groups close on a click outside them.
      document.querySelectorAll('.collection-editorial-filter[open]').forEach((details) => {
        if (!details.contains(target)) details.open = false;
      });
    });

    // One desktop group open at a time.
    document.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        if (!details.matches('.collection-editorial-filter')) return;
        details.parentElement?.querySelectorAll(':scope > .collection-editorial-filter[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.collection-editorial-filter[open]').forEach((details) => {
        const hadFocus = details.contains(document.activeElement);
        details.open = false;
        if (hadFocus) details.querySelector('summary')?.focus();
      });
    });

    window.addEventListener('popstate', (event) => {
      if (!event.state?.[HISTORY_KEY]) return;
      const section = document.querySelector('[data-collection-editorial]');
      if (section) renderSection(section, new URL(window.location.href), { history: 'none' });
    });

    // Marks the entry the page loaded on, so Back to it re-renders too.
    const markHistory = () => {
      if (!document.querySelector('[data-collection-editorial]') || history.state?.[HISTORY_KEY]) return;
      history.replaceState({ ...(history.state || {}), [HISTORY_KEY]: true }, '');
    };

    const showResultsLabels = (root = document) => {
      root.querySelectorAll('[data-collection-apply][data-results-label]').forEach((button) => {
        button.textContent = button.dataset.resultsLabel;
      });
    };

    const updateResultsLabel = async (form) => {
      const button = form.querySelector('[data-collection-apply]');
      if (!button || !form.dataset.sectionId) return;

      const url = formUrl(form);
      // `sections=` (JSON) rather than `section_id=`: `shopify theme dev` intermittently 404s the latter.
      url.searchParams.set('sections', form.dataset.sectionId);

      resultsRequests.get(form)?.abort();
      const controller = new AbortController();
      resultsRequests.set(form, controller);

      try {
        const response = await fetch(url.toString(), { signal: controller.signal });
        if (!response.ok) return;
        const html = (await response.json())?.[form.dataset.sectionId];
        if (resultsRequests.get(form) !== controller || typeof html !== 'string') return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const label = doc.querySelector('[data-collection-apply]')?.getAttribute('data-results-label');
        if (label) button.textContent = label;
      } catch {
        // Aborted or offline: keep the last label; submitting still works.
      }
    };

    const queueResultsLabel = (event) => {
      const form = event.target instanceof Element ? event.target.closest('[data-collection-filter-form]') : null;
      if (!(form instanceof HTMLFormElement) || event.target.matches('[data-filter-search-input]')) return;
      window.clearTimeout(resultsTimers.get(form));
      resultsTimers.set(
        form,
        window.setTimeout(() => updateResultsLabel(form), RESULTS_DEBOUNCE_MS)
      );
    };

    document.addEventListener('input', queueResultsLabel);
    document.addEventListener('change', queueResultsLabel);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) {
        showResultsLabels(event.target);
        showFilterSearch(event.target);
      }
      markHistory();
    });

    const initFilters = () => {
      showResultsLabels();
      showFilterSearch();
      markHistory();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFilters, { once: true });
    } else {
      initFilters();
    }
  }

  // Show more: the next page is prefetched through the Section Rendering API; the click appends its
  // cards and the grid opens downward while they rise in turn. The button stays a real ?page=N link
  // for crawlers and no-JS visitors, and appended pages and scroll come back after Back.
  if (!window.collectionEditorialLoadMoreBound) {
    window.collectionEditorialLoadMoreBound = true;

    const STORE_KEY = 'z82-collection-more';
    const MAX_RESTORE_PAGES = 10;
    // Matches the CSS: the grid opens over 760ms; the last card starts rising at 320ms and takes 680ms.
    const SETTLE_MS = 1060;
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const readState = () => {
      try {
        return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      } catch {
        return null;
      }
    };

    const writeState = (state) => {
      try {
        if (state) sessionStorage.setItem(STORE_KEY, JSON.stringify(state));
        else sessionStorage.removeItem(STORE_KEY);
      } catch {}
    };

    const currentPath = () => window.location.pathname + window.location.search;
    const gridFor = (more) => more.parentElement?.querySelector('.collection-editorial-grid');

    const updateCount = (more) => {
      const count = more.querySelector('[data-collection-more-count]');
      const grid = gridFor(more);
      if (count && grid && more.dataset.countTemplate) {
        count.textContent = more.dataset.countTemplate.replace('[shown]', String(grid.children.length));
      }
    };

    // Fetches one page and returns its cards and the next page URL (or null).
    const fetchPage = async (more, url) => {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', more.dataset.sectionId);
      const response = await fetch(fetchUrl.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('.collection-editorial-grid > .collection-editorial-grid__item')];
      const nextLink = doc.querySelector('[data-collection-more-link]');
      return { items, next: nextLink ? nextLink.getAttribute('href') : null };
    };

    const appendItems = (more, items) => {
      gridFor(more)?.append(...items);
      more.dataset.loadedPages = String((Number(more.dataset.loadedPages) || 1) + 1);
      updateCount(more);
    };

    const setNextLink = (more, next) => {
      const link = more.querySelector('[data-collection-more-link]');
      if (!link) return;
      if (next) link.href = next;
      else link.remove();
    };

    // Prefetches the next page into a hidden holder, so its photos are loaded before the click.
    const prefetchNext = (more) => {
      const link = more.querySelector('[data-collection-more-link]');
      if (!link) return Promise.resolve(null);
      if (more.nextPromise) return more.nextPromise;

      more.nextPromise = fetchPage(more, link.href)
        .then(({ items, next }) => {
          if (!items.length) return null;
          items.forEach((item) => {
            // Main photos load now; the hover photo stays lazy.
            item.querySelectorAll('img[loading="lazy"]:not(.card__img--hover)').forEach((img) => {
              img.loading = 'eager';
            });
          });
          const holder = document.createElement('div');
          holder.hidden = true;
          holder.append(...items);
          more.append(holder);
          return { holder, items, next };
        })
        .catch(() => null);
      return more.nextPromise;
    };

    // Appends the cards to the grid, then opens the grid downward to fit them while they rise in turn.
    // The cards join the real grid at once, so a part-filled last row fills in place instead of jumping.
    const openNext = (more, prepared) =>
      new Promise((resolve) => {
        const { holder, items, next } = prepared;
        const grid = gridFor(more);
        const finish = () => {
          grid.classList.remove('is-opening');
          grid.style.removeProperty('height');
          items.forEach((item) => {
            item.classList.remove('is-new');
            item.style.removeProperty('--enter-index');
          });
          setNextLink(more, next);
          resolve(items[0]);
        };

        more.nextPromise = null;
        if (reduceMotion()) {
          appendItems(more, items);
          holder.remove();
          finish();
          return;
        }

        const startHeight = grid.getBoundingClientRect().height;
        items.forEach((item, index) => {
          item.classList.add('is-new', 'is-entering');
          item.style.setProperty('--enter-index', String(index));
        });
        appendItems(more, items);
        holder.remove();
        const endHeight = grid.getBoundingClientRect().height;
        grid.style.height = `${startHeight}px`;
        grid.getBoundingClientRect();
        grid.classList.add('is-opening');
        grid.style.height = `${endHeight}px`;
        items.forEach((item) => item.classList.remove('is-entering'));
        window.setTimeout(finish, SETTLE_MS);
      });

    // Prefetches the next page as soon as the button gets close to the viewport.
    const watchMore = (more) => {
      if (!more.querySelector('[data-collection-more-link]')) return;
      if (!('IntersectionObserver' in window)) {
        prefetchNext(more);
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          prefetchNext(more);
        },
        { rootMargin: '0px 0px 900px 0px' }
      );
      observer.observe(more);
    };

    document.addEventListener('click', async (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-collection-more-link]') : null;
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const more = link.closest('[data-collection-more]');
      if (!more || !gridFor(more)) return;
      event.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;

      const href = link.href;
      const label = link.textContent;
      more.setAttribute('aria-busy', 'true');
      if (!more.nextPromise) link.textContent = more.dataset.loadingLabel || label;

      try {
        const prepared = await prefetchNext(more);
        link.textContent = label;
        if (!prepared) throw new Error('Next page unavailable');
        const firstNew = await openNext(more, prepared);
        // Keyboard users continue from the first new card instead of jumping back to the top.
        firstNew?.querySelector('a[href]:not([tabindex="-1"])')?.focus({ preventScroll: true });
        watchMore(more);
      } catch {
        // A filter change may have replaced this block meanwhile; only a live button falls back to the page.
        if (more.isConnected) window.location.href = href;
      } finally {
        more.removeAttribute('aria-busy');
      }
    });

    // A filter change swapped in a new list: watch its own Show more (the old prefetch went with the old block).
    document.addEventListener('collection-editorial:render', (event) => {
      const more = event.detail?.section?.querySelector('[data-collection-more]');
      if (more) watchMore(more);
    });

    // Remember how far the visitor loaded, so Back from a product restores the same list and scroll.
    window.addEventListener('pagehide', () => {
      const more = document.querySelector('[data-collection-more]');
      const pages = Number(more?.dataset.loadedPages) || 1;
      writeState(more && pages > 1 ? { path: currentPath(), pages, y: window.scrollY } : null);
    });

    const restore = async (more) => {
      const state = readState();
      const navigation = performance.getEntriesByType('navigation')[0];
      if (!state || state.path !== currentPath() || navigation?.type !== 'back_forward') return;

      const pages = Math.min(state.pages, MAX_RESTORE_PAGES);
      try {
        for (let page = 2; page <= pages; page += 1) {
          const link = more.querySelector('[data-collection-more-link]');
          if (!link) break;
          const { items, next } = await fetchPage(more, link.href);
          appendItems(more, items);
          setNextLink(more, next);
        }
      } catch {
        return;
      }
      if (typeof state.y === 'number') window.scrollTo(0, state.y);
    };

    const init = async () => {
      const more = document.querySelector('[data-collection-more]');
      if (!more) return;
      await restore(more);
      watchMore(more);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
